(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pm-adatsor"] && !Shopify.designMode) return;
  try {
    // Variánsváltáskor a Horizon csak a variánsválasztót morfolja (nem az
  // egész szekciót), ezért a nettó tömeget a variant:update eseményből
  // frissítjük (mint a pm-unit-saving). Mérve: kattintásra a Liquid-érték
  // magától nem változott.
  document.addEventListener('variant:update', function (e) {
    if (!e.detail || !e.detail.resource || !e.detail.resource.title) return;
    var productId = e.detail.data && e.detail.data.productId;
    document.querySelectorAll('[data-pm-adatsor]').forEach(function (el) {
      if (productId && String(el.dataset.productId) !== String(productId)) return;
      var cel = el.querySelector('[data-pm-netto]');
      if (!cel) return;
      var t = e.detail.resource.title;
      if (t === 'Default Title') return;
      cel.textContent = t.replace('ml', ' ml').replace('g', ' g').replace('  ', ' ');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-quick-add"] && !Shopify.designMode) return;
  try {
    if (!window.__pmQuickAddVariantBound) {
    window.__pmQuickAddVariantBound = true;
    document.addEventListener('pm:variant:select', function (e) {
      var card = e.target.closest('.pm-card');
      if (!card) return;
      var btn = card.querySelector('.pm-quick-add__btn');
      if (!btn) return;
      btn.dataset.variantId = e.detail.variantId;
      btn.disabled = !e.detail.available;
    });
  }

    /* A méhecske-animáció (window.pmMehecske) 2026-10-10-tól az assets/pm-mehecske.js-ben él
     (a footer tölti be), hogy a terméklapon is elérhető legyen. */

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pm-quick-add__btn');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    // A meh a gomb ATALLITASA ELOTT indul: a pozicioit tiszta layouton meri.
    // (Merve: forditott sorrendben a szovegcsere utan kenyszeritett layout
    // ~50 ms-ot vitt a kattintasbol.) A repules ideje alatt megy a
    // szerverhivas ES a friss kosar lekerese is, hogy leszallaskor mar
    // ne kelljen ujabb halozati korre varni.
    // Mobilon a ket cel (zold sav / jobb felso sarok) kozul a tavolabbira repul (assets/pm-mehecske.js).
    var repules = window.pmMehecske.repul(btn, { tavolabbi: true });
    btn.disabled = true;
    btn.textContent = '...';
    var hozzaadas = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    })
    .then(function() { return fetch('/cart.js'); })
    .then(function(r) { return r.json(); });
    Promise.all([hozzaadas, repules])
    .then(function(eredmeny) {
      var cart = eredmeny[0];
      btn.textContent = 'Hozzáadva ✓';
      btn.classList.add('pm-quick-add__btn--added');
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      // Trigger the theme's native cart-update flow so the single
      // native cart drawer refreshes its contents and auto-opens
      // (matches the shape of @theme/events CartAddEvent).
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'pm-quick-add', data: {} }
      }));
      // A kosar-fiok most nyilik (legfelso reteg): a meh reteget fole emeljuk,
      // hogy a meh a fiok FOLOTT repuljon tovabb, ne tunjon el mogotte.
      window.pmMehecske.fiokFole();
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = 'Kosárba';
        btn.classList.remove('pm-quick-add__btn--added');
      }, 2000);
    })
    .catch(function() {
      document.dispatchEvent(new CustomEvent('pm:kosar-hiba'));
      btn.textContent = 'Hiba – próbáld újra';
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = 'Kosárba';
      }, 2500);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-stock-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    var MONTHS = [
      'január', 'február', 'március', 'április', 'május', 'június',
      'július', 'augusztus', 'szeptember', 'október', 'november', 'december'
    ];
    var DAYS = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];

    // N. munkanap mától, hétvégét kihagyva.
    function pmAddBusinessDays(days) {
      var d = new Date();
      var counted = 0;
      var guard = 0;
      while (counted < days && guard < 60) {
        d.setDate(d.getDate() + 1);
        guard++;
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) counted++;
      }
      return d;
    }

    // Hűtött termék: a feladás csak a megadott napokon (1 = hétfő … 3 = szerda),
    // a kézbesítés a feladás utáni munkanap.
    function pmShipWindow(el) {
      var days = el.dataset.shipDays.split(',').map(Number);
      function arrival(lead) {
        var d = pmAddBusinessDays(lead);
        var guard = 0;
        while (days.indexOf(d.getDay()) === -1 && guard < 14) {
          d.setDate(d.getDate() + 1);
          guard++;
        }
        var a = new Date(d);
        do { a.setDate(a.getDate() + 1); } while (a.getDay() === 0 || a.getDay() === 6);
        return a;
      }
      return [arrival(1), arrival(2)];
    }

    function pmFormatDate(d) {
      return MONTHS[d.getMonth()] + ' ' + d.getDate() + '., ' + DAYS[d.getDay()];
    }

    function pmRenderEta(el) {
      var eta = el.querySelector('.pm-delivery__eta:not(.pm-delivery__eta--static)');
      if (!eta) return;
      var min = parseInt(el.dataset.leadMin, 10) || 2;
      var max = parseInt(el.dataset.leadMax, 10) || 4;
      var from = pmAddBusinessDays(min);
      var to = pmAddBusinessDays(max);
      if (el.dataset.shipDays) {
        var w = pmShipWindow(el);
        from = w[0];
        to = w[1];
      }
      if (from.toDateString() === to.toDateString()) {
        eta.innerHTML = 'Ha most megrendeled, várhatóan <strong>' + pmFormatDate(from) + '</strong> érkezik meg.';
        return;
      }
      eta.innerHTML =
        'Ha most megrendeled, várhatóan <strong>' +
        pmFormatDate(from) +
        '</strong> és <strong>' +
        pmFormatDate(to) +
        '</strong> között érkezik meg.';
    }

    function pmInitDelivery() {
      document.querySelectorAll('.pm-delivery').forEach(function (el) {
        if (el.querySelector('.pm-delivery__eta[hidden]:not(.pm-delivery__eta--static)')) return;
        pmRenderEta(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pmInitDelivery);
    } else {
      pmInitDelivery();
    }

    document.addEventListener('variant:update', function (e) {
      if (!e.detail || !e.detail.resource) return;
      var productId = e.detail.data && e.detail.data.productId;
      var variant = e.detail.resource;
      document.querySelectorAll('.pm-delivery').forEach(function (el) {
        var wrapper = el.closest('[data-product-id]');
        if (productId && wrapper && wrapper.dataset.productId !== productId) return;

        var status = el.querySelector('.pm-delivery__status');
        var dot = el.querySelector('.pm-delivery__dot');
        var label = el.querySelector('.pm-delivery__label');
        var eta = el.querySelector('.pm-delivery__eta:not(.pm-delivery__eta--static)');
        var staticEta = el.querySelector('.pm-delivery__eta--static');
        if (!status || !dot || !label) return;

        if (variant.available) {
          status.classList.remove('pm-delivery__status--out');
          dot.classList.remove('pm-delivery__dot--out');
          label.textContent = 'Raktáron';
          if (staticEta) staticEta.hidden = true;
          if (eta) {
            eta.hidden = false;
            pmRenderEta(el);
          }
        } else {
          status.classList.add('pm-delivery__status--out');
          dot.classList.add('pm-delivery__dot--out');
          label.textContent = 'Jelenleg nem elérhető';
          if (eta) eta.hidden = true;
          if (staticEta) staticEta.hidden = false;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-unit-saving"] && !Shopify.designMode) return;
  try {
    (function () {
    // A kiszerelés-elemzés egy helyen el: assets/pm-money.js (ott all a
    // magyarazat is arrol, miert nem a Shopify sulyadatabol szamolunk, es
    // miert nincs \b a mintaban).
    function pmUsParse(title) {
      return window.pmMoney.parseSize(title);
    }

    // A formazas egy helyen el: assets/pm-money.js.
    function pmUsHuf(cents) {
      return window.pmMoney.formatHuf(cents);
    }

    function pmUsRender(root, currentTitle) {
      var dataEl = root.querySelector('.pm-unit-saving__data');
      var textEl = root.querySelector('.pm-unit-saving__text');
      if (!dataEl || !textEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        root.hidden = true;
        return;
      }

      var current = null;
      var best = null;
      variants.forEach(function (v) {
        var parsed = pmUsParse(v.title);
        if (!parsed || !v.price) return;
        v._label = parsed.label;
        v._base = parsed.base;
        v._perKg = v.price / parsed.grams * 1000;
        if (v.title === currentTitle) current = v;
        if (!v.available) return;
        if (!best || v._perKg < best._perKg) best = v;
      });

      if (!current || !best || best.title === current.title) {
        root.hidden = true;
        return;
      }

      var saving = (current._perKg - best._perKg) / current._perKg;
      if (!isFinite(saving) || saving < 0.05) {
        root.hidden = true;
        return;
      }

      root.hidden = false;
      textEl.textContent =
        'Az ' + best._label + ' a legkedvezőbb: ' + pmUsHuf(best._perKg) + ' / ' + best._base;

    }

    function pmUsInit() {
      document.querySelectorAll('.pm-unit-saving').forEach(function (root) {
        var pp = document.querySelector(
          '.product-information product-price[data-product-id="' + root.dataset.productId + '"]'
        );
        var title = pp ? pp.dataset.initialTitle : '';
        if (title) pmUsRender(root, title);
      });
    }

    document.addEventListener('variant:update', function (e) {
      if (!e.detail || !e.detail.resource) return;
      var productId = e.detail.data && e.detail.data.productId;
      document.querySelectorAll('.pm-unit-saving').forEach(function (root) {
        if (productId && root.dataset.productId !== String(productId)) return;
        pmUsRender(root, e.detail.resource.title);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pmUsInit);
    } else {
      pmUsInit();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-variant-links"] && !Shopify.designMode) return;
  try {
    if (!window.__pmVariantLinksBound) {
    window.__pmVariantLinksBound = true;

    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.pm-variant-pill');
      if (!pill) return;

      var scope = pill.closest('.pm-card') || pill.closest('.pm-variant-links') || document;
      scope.querySelectorAll('.pm-variant-pill').forEach(function (p) {
        p.classList.remove('selected');
      });
      pill.classList.add('selected');

      scope.dispatchEvent(
        new CustomEvent('pm:variant:select', {
          bubbles: true,
          detail: {
            variantId: pill.dataset.variantId,
            priceInCents: parseInt(pill.dataset.variantPrice, 10),
            title: pill.dataset.variantTitle,
            available: pill.dataset.variantAvailable === 'true',
          },
        })
      );
    });

  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    // A kiszerelés-elemzés egy helyen el: assets/pm-money.js. Korabban itt
    // is es a pm-unit-saving blokkban is kulon masolat volt belole.
    function pmFormatSize(title) {
      var size = window.pmMoney.parseSize(title);
      return size ? size.label : '';
    }

    // Grammban adja vissza a kiszerelést a variáns címéből ("250g", "1kg").
    function pmGramsFromTitle(title) {
      var size = window.pmMoney.parseSize(title);
      return size ? size.grams : 0;
    }

    // A formazas egy helyen el: assets/pm-money.js. Korabban itt is,
    // a bundle-ben es a tapado savban is kulon masolat volt, es
    // ugyanaz a tagolasi hiba jott elo mindharomban.
    function pmFormatHuf(cents) {
      return window.pmMoney.formatHuf(cents);
    }

    function pmRenderKgPrice(display, priceInCents, title) {
      if (!display || !title) return;
      display.textContent = pmFormatSize(title);

      var unitEl = display.parentElement && display.parentElement.querySelector('.pm-unit-price');
      if (!unitEl) return;
      var size = window.pmMoney.parseSize(title);
      var grams = size ? size.grams : 0;
      if (!grams || !priceInCents) {
        unitEl.hidden = true;
        unitEl.textContent = '';
        return;
      }
      unitEl.hidden = false;
      unitEl.textContent = pmFormatHuf(priceInCents / grams * 1000) + ' / ' + size.base;
    }

    if (!window.__pmKgPriceBound) {
      window.__pmKgPriceBound = true;

      // Saját pm-variant-links pill kattintás — kártyánként skálázva (.pm-card)
      document.addEventListener('pm:variant:select', function (e) {
        var card = e.target.closest('.pm-card');
        if (!card) return;
        var display = card.querySelector('.pm-kg-price');
        pmRenderKgPrice(display, e.detail.priceInCents, e.detail.title);

        // 2026-09-12: a metetpillek bevezetesevel a FOAR is a kivalasztott
        // kiszerelest kell mutassa — enelkul a pille atvaltott, de a kartya
        // arra a legkisebb kiszerelese maradt, ami felrevezeto.
        var foAr = card.querySelector('product-price .price');
        if (foAr && e.detail.priceInCents != null && !isNaN(e.detail.priceInCents)) {
          foAr.textContent = pmFormatHuf(e.detail.priceInCents);
        }
      });

      // Horizon saját eseménye valódi variáns-váltásnál (pl. terméklapon)
      // NOTE: variant-picker és product-price testvér elemek a terméklapon (nem egymás leszármazottai),
      // ezért e.target.closest(...) sosem talál semmit itt — a productId alapján kell megkeresni a helyes
      // product-price blokkot, nem a DOM-fa alapján.
      document.addEventListener('variant:update', function (e) {
        if (!e.detail || !e.detail.resource) return;
        var productId = e.detail.data && e.detail.data.productId;
        if (!productId) return;
        document.querySelectorAll('product-price[data-product-id="' + productId + '"]').forEach(function (scope) {
          var display = scope.querySelector('.pm-kg-price');
          pmRenderKgPrice(display, e.detail.resource.price, e.detail.resource.title);
        });
      });

      function pmInitKgPrice(el) {
        if (el.dataset.pmKgInit) return;
        el.dataset.pmKgInit = '1';
        var display = el.querySelector('.pm-kg-price');
        pmRenderKgPrice(display, parseInt(el.dataset.initialPrice, 10), el.dataset.initialTitle);
      }

      // Kezdeti betöltés minden price blokknál egyszerre
      document.querySelectorAll('product-price[data-initial-price]').forEach(pmInitKgPrice);

      // Sok product-price blokk (pl. "Ezeket is kedvelheted" ajánlások) csak
      // aszinkron fetch után kerül a DOM-ba, jóval a fenti kezdeti lekérdezés
      // után — ezekre a fenti querySelectorAll nem vonatkozik, ezért kell egy
      // megfigyelő, ami az utólag beszúrt kártyákat is elkapja.
      var pmKgObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('product-price[data-initial-price]')) {
              pmInitKgPrice(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('product-price[data-initial-price]').forEach(pmInitKgPrice);
            }
          });
        });
      });
      pmKgObserver.observe(document.body, { childList: true, subtree: true });
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    // A kiszerelés-gombok kilóárát tölti ki. A számítás a pm-money.js-ben
  // van, ugyanaz, amit a főár melletti Ft/kg és a „legkedvezőbb" tipp is
  // használ — így a három hely nem tud eltérő számot mutatni.
  (function () {
    function pmVpFill(root) {
      (root || document).querySelectorAll('[data-pm-perkg]').forEach(function (el) {
        if (!window.pmMoney) return;
        var text = window.pmMoney.perKg(el.dataset.pmPrice, el.dataset.pmSize);
        el.textContent = text;
        // Ha nincs értelmes kilóár (pl. a kiszerelés neve nem tartalmaz
        // súlyt), a span üres marad, és a CSS kiveszi a helyét is.
        el.hidden = !text;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { pmVpFill(); });
    } else {
      pmVpFill();
    }

    // A választót a Horizon variánsváltáskor újrarendereli, ilyenkor az
    // üres spanek visszakerülnek a DOM-ba, és újra ki kell tölteni.
    document.addEventListener('variant:update', function () { pmVpFill(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
